export default {
  title: 'Adăugați card',
  buttons: {
    save: 'Salvați',
  },
  feedback: {
    success: 'Card salvat cu succes',
  },
};
